// refactoring work in progress

import { Box, Breadcrumbs, Button, Container, FormControlLabel, Grid, Link, MenuItem, Paper, Stack, Switch, Typography, styled } from "@mui/material";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { VdsPageTitle, VdsSelect, VdsTextField } from "../../@vds";
import { useAlertContext, useLoaderContext } from "../../contexts";
import { AdministrativeItemDTO, CompanyDTO, CountryDTO, GetAdministrativeDivisions, GetCompany, GetCountries } from "../../helpers/api.helpers";
import { GetServers, ServerDTO } from "../../helpers/servers.services";

export const StyledPageContainer = styled('div')(() => ({
    backgroundColor: "var(--vapor-primary-background)",
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
}));

export interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    hidden?: boolean;
    onEnter?: () => void;
}

enum CompanyDetailFormPanels {
    Details = 0,
    Users = 1
}

interface CompanyPageProps {
    companyOid?: string;
}

interface CompanyDetailFormProps {
    companiesPage?: CompanyPageProps,
    companyDetailsPage?: {
        company?: CompanyDTO;
        activePanel?: CompanyDetailFormPanels;
    }
}

export const useCompanyDetailsPage = () => {

    const setLoader = useLoaderContext();
    const navigate = useNavigate();
    const setAlert = useAlertContext();

    const redirectToCompanyForm = ({ pushState, ...state }: {
        company: CompanyDTO;
        servers: ServerDTO[],
        countries: CountryDTO[];
        regions?: AdministrativeItemDTO[];
        provinces?: AdministrativeItemDTO[];
        cities?: AdministrativeItemDTO[];
        activePanel: number;
        pushState?: CompanyPageProps;
    }) => {

        setLoader(false);
        navigate("/app/companies/details", {
            state: {
                companiesPage: pushState,
                companyDetailsPage: state
            }
        });
    }

    const CountryChainFlowIT = (props: {
        company: CompanyDTO;
        servers: ServerDTO[],
        countries: CountryDTO[];
        activePanel: CompanyDetailFormPanels;
        pushState?: CompanyPageProps;
    }) => {

        const { countries } = props;

        const company = props.company;

        // se il country � definito prosegui nel flusso e recupera le regioni e il countryID
        const countryID = countries.find(c => c.iso2Code?.toUpperCase() === company.country?.toUpperCase());
        if (countryID) {

            setLoader(true);
            // se il countryID � definito prosegui nel flusso e recupera le regioni
            GetAdministrativeDivisions({ params: { oid: countryID.oid, orderByDescending: false, orderByPropertyName: 'Description' } })
                .then((regionsResult) => {

                    const regionID = regionsResult.data.administrativeDivisions.find(c => c.description?.toUpperCase() === company.region?.toUpperCase());
                    // la regione potrebbe essere assegnata in modo sbagliato in quel caso non deve essere popolato il campo
                    company.region = regionID ? company.region : "";
                    if (regionID) {

                        // se il regionID � definito prosegui nel flusso e recupera le provincie
                        GetAdministrativeDivisions({ params: { oid: regionID.oid, orderByDescending: false, orderByPropertyName: 'Description' } })
                            .then((provincesResult) => {
                                // se la regione della compagnia � definita prosegui nel flusso e recupera il regionID
                                const provinceID = provincesResult.data.administrativeDivisions.find(c => c.isoCode?.toUpperCase() === company.province?.toUpperCase());
                                // la provincia potrebbe essere assegnata in modo sbagliato in quel caso non deve essere popolato il campo
                                company.province = provinceID ? company.province : "";
                                if (provinceID) {

                                    // se il provinceID � definito prosegui nel flusso e recupera le citt�
                                    GetAdministrativeDivisions({ params: { oid: provinceID.oid, orderByDescending: false, orderByPropertyName: 'Description' } })
                                        .then((citiesResult) => {

                                            const isValidCity = citiesResult.data.administrativeDivisions.find(c => c.description?.toUpperCase() === company.city?.toUpperCase());
                                            // la citt� potrebbe essere assegnata in modo sbagliato in quel caso non deve essere popolato il campo
                                            company.city = isValidCity ? company.city : "";

                                            redirectToCompanyForm({
                                                company,
                                                countries,
                                                servers: props.servers,
                                                regions: regionsResult.data.administrativeDivisions,
                                                provinces: provincesResult.data.administrativeDivisions,
                                                cities: citiesResult.data.administrativeDivisions,
                                                activePanel: props.activePanel,
                                                pushState: props.pushState,
                                            });
                                        }).catch((error) => {
                                            setLoader(false);
                                            const errors = {

                                            }
                                            setAlert({
                                                message: errors[error?.response?.data?.title] || 'Si è verificato un errore imprevisto si prega di riprovare',
                                                severity: 'warning',
                                                open: true,
                                            });
                                        });
                                } else {

                                    company.city = "";

                                    redirectToCompanyForm({
                                        company,
                                        countries,
                                        servers: props.servers,
                                        regions: regionsResult.data.administrativeDivisions,
                                        provinces: provincesResult.data.administrativeDivisions,
                                        activePanel: props.activePanel,
                                        pushState: props.pushState,
                                    });
                                }
                            }).catch((error) => {
                                setLoader(false);
                                const errors = {

                                }
                                setAlert({
                                    message: errors[error?.response?.data?.title] || 'Si è verificato un errore imprevisto si prega di riprovare',
                                    severity: 'warning',
                                    open: true,
                                });
                            });
                    } else {

                        company.province = "";
                        company.city = "";

                        redirectToCompanyForm({
                            company,
                            servers: props.servers,
                            countries,
                            regions: regionsResult.data.administrativeDivisions,
                            activePanel: props.activePanel,
                            pushState: props.pushState,
                        });
                    }
                }).catch((error) => {
                    setLoader(false);
                    const errors = {

                    }
                    setAlert({
                        message: errors[error?.response?.data?.title] || 'Si è verificato un errore imprevisto si prega di riprovare',
                        severity: 'warning',
                        open: true,
                    });
                });
        } else {

            redirectToCompanyForm({
                company,
                countries,
                servers: props.servers,
                activePanel: props.activePanel,
                pushState: props.pushState,
            });
        }
    }

    const GenericCountryChainFlow = (props: {
        company: CompanyDTO;
        servers: ServerDTO[],
        countries: CountryDTO[];
        activePanel: CompanyDetailFormPanels;
        pushState?: CompanyPageProps;
    }) => {

        const { countries } = props;
        const company = props.company;

        // se il country � definito prosegui nel flusso e recupera le regioni e il countryID
        const countryID = countries.find(c => c.iso2Code.toUpperCase() === company.country?.toUpperCase());

        if (countryID) {
            company.region = company.city ? company.region : "";
        }

        redirectToCompanyForm({
            company,
            countries,
            servers: props.servers,
            activePanel: props.activePanel,
            pushState: props.pushState
        });
    }

    const buyActionOnClick = (company: CompanyDTO, servers: ServerDTO[], activePanel: CompanyDetailFormPanels, pushState?: CompanyPageProps) => {

        setLoader(true);
        GetCountries({
            params: {
                orderByDescending: false,
                orderByPropertyName: 'Description'
            }
        })
            .then((countriesResult) => {
                if (company.country === COUNTRY_IT) {
                    CountryChainFlowIT({
                        company,
                        servers,
                        countries: countriesResult.data.countries,
                        activePanel,
                        pushState
                    });
                } else {
                    GenericCountryChainFlow({
                        company,
                        servers,
                        countries: countriesResult.data.countries,
                        activePanel,
                        pushState
                    });
                }
            }).catch((error) => {
                setLoader(false);
                const errors = {

                }
                setAlert({
                    message: errors[error?.response?.data?.title] || 'Si è verificato un errore imprevisto si prega di riprovare',
                    severity: 'warning',
                    open: true,
                });
            });
    };

    return (oid: string | null, activePanel?: CompanyDetailFormPanels, pushState?: CompanyPageProps) => {

        setLoader(true);
        GetServers({ params: { pageNumber: 1, pageSize: 100000, orderByDescending: false, orderByPropertyName: 'Name' } })
            .then((serversResponse) => {

                setLoader(false);
                if (oid) {
                    setLoader(true);
                    GetCompany({ query: { oid } })
                        .then((response) => {

                            setLoader(false);
                            buyActionOnClick(response.data, serversResponse.data.servers, activePanel, pushState);
                        }).catch((error) => {
                            setLoader(false);
                            const errors = {

                            }
                            setAlert({
                                message: errors[error?.response?.data?.title] || 'Si è verificato un errore imprevisto si prega di riprovare',
                                severity: 'warning',
                                open: true,
                            });
                        });
                }
            }).catch((error) => {
                setLoader(false);
                const errors = {

                }
                setAlert({
                    message: errors[error?.response?.data?.title] || 'Si è verificato un errore imprevisto si prega di riprovare',
                    severity: 'warning',
                    open: true,
                });
            });

    }
}

export const CompanyDetailsPage = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const locationState = location?.state as CompanyDetailFormProps;

    const navigateToCompaniesPage = (state?: CompanyDetailFormProps) => {
        navigate('/app', { state });
    }

    const {
        countries,
        servers,
        ...rest
    } = useLocationState();

    const formik = { values: locationState?.companyDetailsPage?.company };

    return (
        <StyledPageContainer>
            <VdsPageTitle
                title={`Azienda '${formik.values.name}'`}
                historyBackEvent={() => {
                    navigateToCompaniesPage({
                        ...locationState,
                        companiesPage: {
                            ...locationState.companiesPage,
                            companyOid: formik.values.oid
                        }
                    })
                }}
                content={
                    <Breadcrumbs sx={{ display: 'flex', alignItems: 'center' }}>
                        <Link
                            onClick={() => {
                                navigateToCompaniesPage({
                                    ...locationState,
                                    companiesPage: {
                                        ...locationState.companiesPage,
                                        companyOid: formik.values.oid
                                    }
                                })
                            }}
                        >
                            Home
                        </Link>
                        <Typography>{formik.values.name}</Typography>
                    </Breadcrumbs>
                }
            />
            <Container
                component="form"
                noValidate
                autoComplete="off"
                spellCheck="false"
                maxWidth="md"
                style={{ height: 'calc(100% - 116px)', overflow: 'auto' }}
            >
                <Paper variant="outlined" style={{ padding: '25px 50px', display: 'flex', flexDirection: 'column' }}>
                    <Box>
                        <Grid
                            container
                            spacing={2}
                        >
                            <Grid xs={12} item>
                                <StyledSecondaryText2>Dati tecnici</StyledSecondaryText2>
                            </Grid>
                            <Grid xs={12} sm={12} md={4} lg={6} item>
                                <VdsTextField
                                    label="Codice cliente"
                                    name="clientCode"
                                    value={formik.values.clientCode}
                                    collapse
                                    readOnly
                                />
                            </Grid>
                            <Grid xs={12} sm={12} md={4} lg={6} item>
                                <VdsSelect
                                    label="Server"
                                    MenuProps={{
                                        PaperProps: { style: { maxHeight: 224, width: 250 } }
                                    }}
                                    value={formik.values.serverOid || ''}
                                    name="serverOid"
                                    readOnly
                                    displayEmpty
                                    collapse
                                    fullWidth
                                >
                                    {servers?.map((server) => (
                                        <MenuItem
                                            key={server.oid}
                                            value={server.oid}
                                        >
                                            <Box data-oid={server.oid}>
                                                {`${server.name}`}
                                            </Box>
                                        </MenuItem>
                                    ))}
                                </VdsSelect>
                            </Grid>
                            <Grid xs={12} item>
                                <StyledSecondaryText2>Dati Azienda</StyledSecondaryText2>
                            </Grid>
                            <Grid xs={12} sm={12} md={6} lg={6} item>
                                <VdsTextField
                                    label="Name"
                                    name="name"
                                    value={formik.values.name}
                                    collapse
                                    readOnly
                                />
                            </Grid>
                            <Grid xs={12} sm={12} md={3} lg={3} item>
                                <VdsTextField
                                    label="Partita IVA"
                                    name="vatCode"
                                    value={formik.values.vatCode}
                                    collapse
                                    readOnly
                                />
                            </Grid>
                            <Grid xs={12} sm={12} md={3} lg={3} item>
                                <VdsTextField
                                    label={formik.values.country === COUNTRY_IT ? 'Codice fiscale*' : 'Codice*'}
                                    name="fiscalCode"
                                    value={formik.values.fiscalCode}
                                    collapse
                                    readOnly
                                />
                            </Grid>
                            <Grid xs={12} sm={12} md={3} lg={3} item >
                                <VdsSelect
                                    label="Paese*"
                                    MenuProps={{
                                        PaperProps: { style: { maxHeight: 224, width: 250 } }
                                    }}
                                    value={formik.values.country}
                                    name="country"
                                    collapse
                                    fullWidth
                                    readOnly
                                >
                                    {countries?.map((country) => (
                                        <MenuItem
                                            key={country.oid}
                                            value={country.iso2Code.toUpperCase()}
                                        >
                                            <Box data-oid={country.oid}>
                                                {`${country.description}`}
                                            </Box>
                                        </MenuItem>
                                    ))}
                                </VdsSelect>
                            </Grid>
                            <Grid xs={12} sm={12} md={3} lg={3} item>
                                {formik.values.country === COUNTRY_IT ? (
                                    <VdsSelect
                                        label="Regione"
                                        MenuProps={{
                                            PaperProps: { style: { maxHeight: 224, width: 250 } }
                                        }}
                                        value={formik.values.region?.toUpperCase() || ''}
                                        name="region"
                                        collapse
                                        fullWidth
                                        readOnly
                                    >
                                        {rest.regions?.map((country) => (
                                            <MenuItem
                                                key={country.oid}
                                                value={country.description.toUpperCase()}
                                            >
                                                {`${country.description}`}
                                            </MenuItem>
                                        ))}
                                    </VdsSelect>
                                ) : (
                                    <VdsTextField
                                        label="Area amministrativa"
                                        value={formik.values.region || ''}
                                        readOnly
                                        name="region"
                                        collapse
                                    />
                                )}
                            </Grid>
                            <Grid xs={12} sm={12} md={3} lg={3} item>
                                {formik.values.country === COUNTRY_IT ? (
                                    <VdsSelect
                                        label="Provincia"
                                        MenuProps={{
                                            PaperProps: { style: { maxHeight: 224, width: 250 } }
                                        }}
                                        value={formik.values.province?.toUpperCase() || ''}
                                        name="province"
                                        collapse
                                        readOnly
                                        fullWidth
                                    >
                                        {rest.provinces?.map((country) => (
                                            <MenuItem
                                                key={country.oid}
                                                value={country.isoCode.toUpperCase()}
                                            >
                                                {`${country.description}`}
                                            </MenuItem>
                                        ))}
                                    </VdsSelect>
                                ) : (
                                    <VdsTextField
                                        label="Area sub amministrativa"
                                        value={formik.values.province || ''}
                                        name="province"
                                        collapse
                                        readOnly
                                    />
                                )}
                            </Grid>
                            <Grid xs={12} sm={12} md={3} lg={3} item>
                                {formik.values.country === COUNTRY_IT ? (
                                    <VdsSelect
                                        label="Città"
                                        MenuProps={{
                                            PaperProps: { style: { maxHeight: 224, width: 250 } }
                                        }}
                                        value={formik.values.city?.toUpperCase() || ''}
                                        name="city"
                                        collapse
                                        fullWidth
                                        readOnly
                                    >
                                        {rest.cities?.map((country) => (
                                            <MenuItem
                                                key={country.oid}
                                                value={country.description.toUpperCase()}
                                            >
                                                {`${country.description}`}
                                            </MenuItem>
                                        ))}
                                    </VdsSelect>
                                ) : (
                                    <VdsTextField
                                        label="Città"
                                        name="city"
                                        value={formik.values.city || ''}
                                        collapse
                                        readOnly
                                    />
                                )}
                            </Grid>
                            <Grid xs={12} sm={12} md={3} lg={3} item>
                                <VdsTextField
                                    label="CAP"
                                    name="postalCode"
                                    value={formik.values.postalCode || ''}
                                    collapse
                                    readOnly
                                />
                            </Grid>
                            <Grid xs={12} sm={12} md={9} lg={9} item>
                                <VdsTextField
                                    label="Indirizzo"
                                    name="address"
                                    value={formik.values.address}
                                    collapse
                                    readOnly
                                />
                            </Grid>
                            <Grid xs={12} sm={12} md={6} lg={6} item>
                                <VdsTextField
                                    label="Email"
                                    name="email"
                                    value={formik.values.email || ''}
                                    collapse
                                    readOnly
                                />
                            </Grid>
                            <Grid xs={12} sm={12} md={6} lg={6} item>
                                <VdsTextField
                                    label="Pec"
                                    name="pec"
                                    value={formik.values.pec || ''}
                                    collapse
                                    readOnly
                                />
                            </Grid>
                            <Grid xs={12} sm={12} md={6} lg={6} item>
                                <VdsTextField
                                    label="Telefono"
                                    name="phoneNumber"
                                    value={formik.values.phoneNumber || ''}
                                    collapse
                                    readOnly
                                />
                            </Grid>
                            <Grid xs={12} sm={12} md={6} lg={6} item>
                                <VdsTextField
                                    label="Fax"
                                    name="faxNumber"
                                    value={formik.values.faxNumber || ''}
                                    collapse
                                    readOnly
                                />
                            </Grid>
                            <Grid xs={12} item>
                                <VdsTextField
                                    label="Note"
                                    name="description"
                                    value={formik.values.description || ''}
                                    collapse
                                    readOnly
                                />
                            </Grid>
                            <Grid xs={12} sm={12} md={6} lg={6} item>
                                <FormControlLabel
                                    label="Abilitata"
                                    control={(
                                        <Switch
                                            name="enabled"
                                            checked={formik.values.enabled}
                                            readOnly
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid xs={12} display="flex" alignItems="center" justifyContent="space-between" item>
                                <Stack spacing={2} direction="row">
                                </Stack>
                                <Stack spacing={2} direction="row" justifyContent="end">
                                    <Button
                                        color="primary"
                                        variant="outlined"
                                        onClick={() => navigateToCompaniesPage({ companiesPage: { companyOid: formik.values.oid } })}
                                    >
                                        Indietro
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Box >

                </Paper>
            </Container>
        </StyledPageContainer>
    );
};

const useLocationState = () => {

    const location = useLocation();
    const locationState = location.state.companyDetailsPage;

    const countries: CountryDTO[] | null = locationState.countries || null;
    const regions: AdministrativeItemDTO[] | null = locationState.regions || null;
    const provinces: AdministrativeItemDTO[] | null = locationState.provinces || null;
    const cities: AdministrativeItemDTO[] | null = locationState.cities || null;
    const servers: ServerDTO[] | null = locationState.servers || null;

    return {
        countries,
        regions,
        provinces,
        cities,
        servers
    }
};

export const COUNTRY_IT = "IT";

const StyledSecondaryText2 = styled('span')(() => ({
    fontSize: "20px",
    color: "#005075",
    letterSpacing: "0.15px",
    lineHeight: "24px",
    fontWeight: 400,
    textAlign: "left"
}));
